import { getLocalStorage, setLocalStorage } from './browserStorageHandler';
import {
  GDPRAPPIES,
  ONETRUSTACTIVEGROUPS,
  TCSTRING
} from './constants/localStorageConstants';

// One Trust scripts
export const oneTrustScript = () => {
  return (
    <>
      <>
        <script
          defer
          type="text/javascript"
          src={`https://cdn.cookielaw.org/consent/${process.env.NEXT_PUBLIC_ONETRUST_ID}/OtAutoBlock.js`}></script>
      </>
      <>
        <script
          defer
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          type="text/javascript"
          data-domain-script={process.env.NEXT_PUBLIC_ONETRUST_ID}></script>
      </>
      <script type="text/javascript">{`function OptanonWrapper() { }`}</script>
    </>
  );
};

export const oneTrustInitialization = () => {
  const activeGroup = window?.OnetrustActiveGroups ?? '';
  setLocalStorage(ONETRUSTACTIVEGROUPS, activeGroup);
  if (window && window?.__tcfapi) {
    window?.__tcfapi('getTCData', 2, (e) => {
      setLocalStorage(TCSTRING, e?.tcString);
      setLocalStorage(GDPRAPPIES, e?.gdprApplies ? 1 : 0);
    });
  }
};

export const oneTrustLoad = (pathName: string, countryCode: string) => {
  const excludedPathsForOneTrust = [
    '/signin',
    '/register',
    '/myaccount/account-info',
    '/myaccount/subscription',
    '/device',
    '/student',
    '/verify-email',
    '/verify-mobile-number',
    '/enter-details'
  ];
  const isRestrictedPathname = excludedPathsForOneTrust.find((item) => {
    return pathName.includes(item);
  });
  const prevActiveGroup = getLocalStorage(ONETRUSTACTIVEGROUPS);
  if (
    window?.OnetrustActiveGroups &&
    window?.OnetrustActiveGroups !== prevActiveGroup &&
    ONE_TRUST_COOKIE_CONTRIES.includes(countryCode) &&
    !isRestrictedPathname
  ) {
    const activeGroup = window.OnetrustActiveGroups;
    setLocalStorage(ONETRUSTACTIVEGROUPS, activeGroup);
    const tcString = getLocalStorage(TCSTRING);
    const gdpr = getLocalStorage(GDPRAPPIES);
    if (window && window.__tcfapi) {
      window.__tcfapi('getTCData', 2, (e: any) => {
        if (tcString !== e.tcString) {
          setLocalStorage(TCSTRING, e.tcString);
        }
        if (gdpr !== e.gdprApplies) {
          setLocalStorage(GDPRAPPIES, e.gdprApplies ? 1 : 0);
        }
      });
    }
    window.location.reload();
  }
};

export const ONE_TRUST_COOKIE_CONTRIES = [
  'SA',
  'HK',
  'EG',
  'KE',
  'KW',
  'VN',
  'SG',
  'CA',
  'IL',
  'BB',
  'UY',
  'ZA',
  'TH',
  'ID',
  'AL',
  'TR',
  'BR',
  'RU',
  'PH',
  'AE',
  'MY',
  'MA',
  'KP',
  'CO',
  'JP',
  'KR',
  'CN',
  'AR',
  'AM',
  'AD',
  'US',
  'MX',
  'GB',
  'SZ',
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE'
];
